import { Component, HostBinding, Input, OnInit } from "@angular/core";
import icHome from "@iconify/icons-ic/twotone-home";
import { trackByValue } from "../../utils/track-by";
import { LanguageService } from 'src/app/pages/Services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: "nc-breadcrumbs",
  templateUrl: "./breadcrumbs.component.html",
  styleUrls: ["./breadcrumbs.component.scss"],
})
export class BreadcrumbsComponent implements OnInit {
  @Input() crumbs: any[] = [{item:"",path:""}];

  @Input()
  @HostBinding("class.invert")
  invert: boolean;

  trackByValue = trackByValue;
  icHome = icHome;

  //language code
  lang$: Observable<string>;

  constructor(
    private translateService: TranslateService,
    public languageService: LanguageService) {
    this.lang$ = this.languageService.getLanguage();
  }

  ngOnInit() {
    this.lang$.subscribe((lang) => this.translateService.use(lang['fileName']));
    
  }
  historyData: any[] = [];

  
  //breadcrumbs code
  dashboardClicked() {
    // this.navigationService.crumbs = ["Dashboard"];
    // this.navigationService.currentRoute = { menuName: "Dashboard" };
    // localStorage.setItem("currentRoute", JSON.stringify({ menuName: "Dashboard" }));
  }
}
